import { render, staticRenderFns } from "./clamp-text.vue?vue&type=template&id=541d3a2b"
import script from "./clamp-text.vue?vue&type=script&lang=js"
export * from "./clamp-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports